export {default as HgComposableDetailsSection} from './_components/HgComposableDetailsSection'
